import { useFlags } from 'launchdarkly-react-client-sdk';

import { Flags } from '@setvi/shared/enums';

/**
 * Whether presentation Templates surfaces show (the Presentations page tab
 * and the Add from SETVI option): hidden only when the `templates` LD flag
 * is explicitly off. While the flag does not exist in LD it comes back
 * undefined, and Templates keep showing as they always have.
 */
export const useTemplatesEnabled = (): boolean => {
  const flags = useFlags();
  return flags?.[Flags.TEMPLATES] !== false;
};
